import { useParams } from 'react-router-dom';

import { useParticipantsSprintsQuery } from 'features/sprint/hooks/query/useParticipantsSprints';
import { useSharedSprintsQuery } from 'features/sprint/hooks/query/useSharedSprints';
import { USER_MODES } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';

export const useSprints = (email) => {
  const userMode = useUserMode();
  const params = useParams();
  const participantEmail = email || params.email;

  const participantSprintsQueryData = useParticipantsSprintsQuery();
  const sharedQueryData = useSharedSprintsQuery(participantEmail, {
    enabled: userMode === USER_MODES.users,
  });

  return userMode === USER_MODES.users
    ? sharedQueryData
    : participantSprintsQueryData;
};
